import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowButton from '../../../../../components/arrow-button';
import { DialogConfirmation } from '../../../../../components/dialog/confirmation';
import { useErrors } from '../../../../../hooks/errors/use-errors';
import { toastSuccess } from '../../../../../utils/toast';
import { useDeviceRestart } from '../../../api/device/device.hooks';

type DeviceRestartProps = {
  deviceId: string;
};

const DeviceRestart: React.FC<DeviceRestartProps> = ({ deviceId }) => {
  const { t } = useTranslation('device-settings');
  const { t: tc } = useTranslation('common');
  const [showDialog, setShowDialog] = useState<boolean>(false);
  const { handleLavvaResolve } = useErrors();
  const { mutate } = useDeviceRestart();

  const handleReset = () => {
    mutate(
      { deviceId },
      {
        onSuccess: ({ data }) => {
          setShowDialog(false);
          handleLavvaResolve({
            status: data.publishStatus,
            deviceId,
            onSuccess: () => toastSuccess({ content: t('restartDevice.success') }),
          });
        },
      },
    );
  };

  return (
    <>
      <ArrowButton title={t('restartDevice.button')} onClick={() => setShowDialog(true)} small className="m-b-24" />
      <DialogConfirmation
        show={showDialog}
        setShow={setShowDialog}
        header={t('restartDevice.popupHeader')}
        content={t('restartDevice.popupContent')}
        primaryBtnText={tc('buttons.continue')}
        secondaryBtnText={tc('buttons.cancel')}
        primaryBtnAction={handleReset}
        secondaryBtnAction={() => setShowDialog(false)}
        timer
      />
    </>
  );
};

export default DeviceRestart;
